import React from 'react';
import { Link, LinkProps } from '@material-ui/core';
import { useStyles } from './LinkPrimaryStyles';
import clsx from 'clsx';

interface ILinkPrimary extends LinkProps {
  disabled?: boolean;
}

export const LinkPrimary: React.FC<ILinkPrimary> = ({
  href,
  onClick,
  children,
  className,
  underline,
  disabled,
  ...props
}: ILinkPrimary) => {
  const classes = useStyles();
  const component = href ? 'a' : 'button';

  if (disabled) {
    return <Link className={classes.disabled}>{children}</Link>;
  } else {
    return (
      <Link
        component={component}
        type={component === 'button' ? 'button' : undefined}
        className={clsx(classes.root, className, underline !== 'none' ? classes.underline : '')}
        href={href}
        onClick={onClick}
        {...props}
      >
        {children}
      </Link>
    );
  }
};

LinkPrimary.defaultProps = {
  disabled: false,
};

export default LinkPrimary;
